import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const testimonials = [
  { key: 'testimonial1' },
  { key: 'testimonial2' },
  { key: 'testimonial3' },
];

export const OmniTestimonials = () => {
  const { t } = useTranslation('landing');

  return (
    <Box
      component="section"
      sx={{
        backgroundColor: '#fff',
        py: '100px',
      }}
    >
      <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 2, md: 4 } }}>
        {/* Section label */}
        <Typography
          className="omni-reveal"
          sx={{
            textAlign: 'center',
            fontSize: 14,
            fontWeight: 700,
            letterSpacing: 2,
            textTransform: 'uppercase',
            color: '#3664D1',
            mb: 1.5,
          }}
        >
          {t('testimonials.label')}
        </Typography>

        {/* Section title */}
        <Typography
          variant="h3"
          className="omni-reveal omni-reveal-delay-1"
          sx={{
            textAlign: 'center',
            fontWeight: 800,
            fontSize: { xs: 28, md: 36 },
            color: '#0f1729',
            mb: 1.5,
          }}
        >
          {t('testimonials.title')}
        </Typography>

        {/* Section subtitle */}
        <Typography
          className="omni-reveal omni-reveal-delay-2"
          sx={{
            textAlign: 'center',
            fontSize: { xs: 16, md: 18 },
            color: '#6b7280',
            mb: 6,
            maxWidth: 600,
            mx: 'auto',
          }}
        >
          {t('testimonials.subtitle')}
        </Typography>

        {/* Grid of 3 testimonial cards */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: 3,
          }}
        >
          {testimonials.map((item, index) => {
            const delayClass =
              index === 0
                ? ''
                : index === 1
                ? 'omni-reveal-delay-1'
                : 'omni-reveal-delay-2';

            const avatarInitial = t(`testimonials.${item.key}.avatar`);

            return (
              <Box
                key={item.key}
                className={`omni-testimonial-card omni-reveal ${delayClass}`}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                }}
              >
                {/* Quote text with left blue border */}
                <Typography
                  sx={{
                    fontSize: 15,
                    color: '#374151',
                    lineHeight: 1.7,
                    borderLeft: '3px solid #3664D1',
                    pl: 2,
                    mb: 3,
                  }}
                >
                  {t(`testimonials.${item.key}.quote`)}
                </Typography>

                {/* Author section */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  {/* Avatar circle */}
                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      borderRadius: '50%',
                      backgroundColor: '#3664D1',
                      color: '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 700,
                      fontSize: 18,
                      flexShrink: 0,
                    }}
                  >
                    {avatarInitial}
                  </Box>

                  {/* Name + position */}
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: 15,
                        color: '#0f1729',
                      }}
                    >
                      {t(`testimonials.${item.key}.name`)}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 14,
                        color: '#6b7280',
                      }}
                    >
                      {t(`testimonials.${item.key}.position`)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};
